import React, { memo, useContext } from 'react';
import { Highlight } from 'react-instantsearch-hooks-web';
import CustomLink from '../CustomLink/CustomLink';
import SbImage from '../SbImage/SbImage';
import { pushToDataLayer } from '../../utils/pushToDataLayer/pushToDataLayer.util';
import { DataLayerContext } from '../../contexts/DataLayerContext';

interface PageNotFoundSearchResultHitProps {
  hit: any;
  dataLayer?: {
    search_term: string;
    search_url: string;
    search_site: string;
  };
}

const PageNotFoundSearchResultHit: React.FC<
  PageNotFoundSearchResultHitProps
> = ({ hit, ...props }) => {
  const { dataLayer } = useContext(DataLayerContext);

  const handleDataLayerClickEvent = (articleTitle: string): void => {
    pushToDataLayer({
      event: 'article_click',
      data: {
        article_title: articleTitle,
      },
    });
  };

  return (
    <CustomLink
      url={hit.full_slug}
      label={hit.heading}
      className="flex justify-start items-stretch gap-x-4 group py-6"
      onClick={() =>
        pushToDataLayer({
          event: '404_site_search',
          data: {
            '404_site_term': dataLayer.search_term,
            '404_search_url': hit.full_slug,
            '404_search_site': dataLayer.search_site,
          },
        })
      }
    >
      <div className="min-w-[108px] hidden sm:block">
        {hit.image?.filename && (
          <SbImage
            asset={hit.image}
            options={{
              width: 108,
              height: 108,
              sizes: { base: 128 },
              className: 'w-full',
            }}
          />
        )}
      </div>
      <div className="space-y-1">
        {hit.heading && (
          <p className="text-left font-bold group-hover:text-text/body-primary-highlight xl:text-lg">
            <Highlight
              attribute="heading"
              classNames={{
                highlighted: 'bg-button/primary-bg text-system/white',
              }}
              hit={hit}
            />
          </p>
        )}
        {hit.body && (
          <p className="text-left text-sm xl:text-base">
            <Highlight
              attribute="body"
              classNames={{
                highlighted: 'bg-button/primary-bg text-system/white',
              }}
              hit={hit}
            />
          </p>
        )}
      </div>
      <div className="flex items-center">
        <div
          className="bg-no-repeat min-w-[1.5em] min-h-[1.5em] w-[1.5em] h-[1.5em] bg-[#006FA7]"
          style={{
            WebkitMaskImage: "url('/svgs/right-arrow.svg')",
            maskImage: "url('/svgs/right-arrow.svg')",
          }}
        />
      </div>
    </CustomLink>
  );
};

export default memo(PageNotFoundSearchResultHit);
